var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6748 8.07317C4.6748 6.1421 4.6748 5.17658 5.27231 4.57668C5.86981 3.97678 6.83147 3.97678 8.7548 3.97678H10.7948C12.7181 3.97678 13.6798 3.97678 14.2773 4.57668C14.8748 5.17658 14.8748 6.14211 14.8748 8.07317V11.4868C14.8748 13.4179 14.8748 14.3834 14.2773 14.9833C13.6798 15.5832 12.7181 15.5832 10.7948 15.5832H8.7548C6.83147 15.5832 5.86981 15.5832 5.27231 14.9833C4.6748 14.3834 4.6748 13.4179 4.6748 11.4868V8.07317Z",
    fill: "#8EB4C3",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2.95486 2.24653C2.125 3.0764 2.125 4.41204 2.125 7.08334V8.50001C2.125 11.1713 2.125 12.507 2.95486 13.3368C3.3923 13.7743 3.97028 13.9811 4.81033 14.0789C4.67472 13.4833 4.67472 12.6647 4.67472 11.4868V8.07316C4.67472 6.14211 4.67472 5.17658 5.27222 4.57667C5.86972 3.97677 6.83139 3.97677 8.75472 3.97677H10.7947C11.9648 3.97677 12.779 3.97677 13.3717 4.11184C13.2744 3.26646 13.0676 2.68568 12.6284 2.24653C11.7986 1.41667 10.4629 1.41667 7.79167 1.41667C5.12037 1.41667 3.78473 1.41667 2.95486 2.24653Z",
    fill: "#8EB4C3",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.e51b8932b6c756854a0e2611f37c13ca.svg";
export { ForwardRef as ReactComponent };